import { render, staticRenderFns } from "./XtendSettings.vue?vue&type=template&id=0bed7d2a&"
import script from "./XtendSettings.vue?vue&type=script&lang=js&"
export * from "./XtendSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports